import moment from 'moment';

export const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY';
export const DISPLAY_TIME_FORMAT = 'HH:mm:ss';
export const DISPLAY_TIME_SHORT_FORMAT = 'HH:mm';

export const formatDisplayDate = (value, fallback = '-') => {
    if (!value) return fallback;

    const parsed = moment(value);
    return parsed.isValid() ? parsed.format(DISPLAY_DATE_FORMAT) : fallback;
};

export const formatDisplayDateTime = (
    value,
    {
        fallback = '-',
        timeFormat = DISPLAY_TIME_SHORT_FORMAT
    } = {}
) => {
    if (!value) return fallback;

    const parsed = moment(value);
    return parsed.isValid() ? parsed.format(`${DISPLAY_DATE_FORMAT} ${timeFormat}`) : fallback;
};

export const formatDisplayDateRange = (fromDate, toDate, fallback = '-') => {
    const from = formatDisplayDate(fromDate, '');
    const to = formatDisplayDate(toDate, '');

    if (!from && !to) return fallback;
    if (from && to) return `${from} to ${to}`;
    return from || to || fallback;
};
